import { apiGet, apiPost } from "@/lib/api";

export const fetchPlans = () => apiGet("/billing/plans");
export const fetchBillingMe = () => apiGet("/billing/me");
export const createCheckout = (plan_id) =>
  apiPost("/billing/checkout", { plan_id });
export const sandboxSimulateSuccess = (order_id) =>
  apiPost("/billing/sandbox-simulate-success", { order_id });

/**
 * Submit the PayHere checkout form via a hidden HTML form (PayHere's
 * recommended pattern for hosted checkout). Opens in same tab.
 */
export const launchPayHereCheckout = (checkout) => {
  if (!checkout || !checkout.fields) {
    throw new Error("Invalid checkout payload");
  }
  const form = document.createElement("form");
  form.method = checkout.method || "POST";
  form.action = checkout.checkout_url;
  form.style.display = "none";
  Object.entries(checkout.fields).forEach(([k, v]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = k;
    input.value = v == null ? "" : String(v);
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
  setTimeout(() => form.remove(), 1000);
};

export const fmtLKR = (n) =>
  `Rs ${Number(n || 0).toLocaleString("en-LK", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;

export const featureMatrix = {
  free: {
    label: "Free",
    price: 0,
    features: [
      "Top 50 stocks in screener",
      "1 portfolio · max 5 holdings",
      "Composite score (no breakdown)",
      "3 AI chat questions / day",
      "Daily market snapshot",
    ],
    notIncluded: [
      "Full screener (all 266 companies)",
      "Score layer breakdown",
      "Backtesting",
      "CSV export",
    ],
  },
  basic: {
    label: "Basic",
    price: 990,
    features: [
      "Full screener (all 266 companies)",
      "3 portfolios · unlimited holdings",
      "Full 5-layer score breakdown",
      "30 AI chat questions / day",
      "Watchlist · email alerts",
      "Brokerage & WHT-aware projections",
      "Investment rationales",
    ],
  },
  premium: {
    label: "Premium",
    price: 2490,
    features: [
      "Everything in Basic",
      "Unlimited AI chat (Claude Sonnet)",
      "Backtesting (when 90 days of data ready)",
      "Quarterly broker-research summaries",
      "Sector deep-dives",
      "CSV export of all data",
      "Priority email support",
      "Early access to new features",
    ],
  },
};
